import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "../components/layouts/auth-layout";
import LoginType from "../containers/auth/login-type";
import Login from "../containers/auth/login";
import OtpVerification from "../containers/auth/otp-verification";
import SignUp from "../containers/auth/sign-up";
import RegisterInformation from "../containers/auth/register-business";
import ResetPassword from "../containers/auth/reset-password";
import AmbassadorRole from "../containers/auth/ambassador-role";
const AuthRoutes = () => {
  return (
    <AuthLayout>
      <Routes>
        <Route path="/login-type" Component={LoginType} />
        <Route path="/register-info" Component={RegisterInformation} />
        <Route path="/login" Component={Login} />
        <Route path="/otp-verification" Component={OtpVerification} />
        <Route path="/reset-password" Component={ResetPassword} />
        <Route path="/sign-up" Component={SignUp} />
        <Route path="/ambassador-role" Component={AmbassadorRole} />

        
      </Routes>
    </AuthLayout>
  );
};

export default AuthRoutes;
